var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 1.66699H4.99967C4.55765 1.66699 4.13372 1.84259 3.82116 2.15515C3.5086 2.46771 3.33301 2.89163 3.33301 3.33366V16.667C3.33301 17.109 3.5086 17.5329 3.82116 17.8455C4.13372 18.1581 4.55765 18.3337 4.99967 18.3337H14.9997C15.4417 18.3337 15.8656 18.1581 16.1782 17.8455C16.4907 17.5329 16.6663 17.109 16.6663 16.667V6.66699L11.6663 1.66699Z",
    stroke: "#808191",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 1.66699V6.66699H16.667",
    stroke: "#808191",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27150_14870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.65278 15.4306C11.1869 15.4306 12.4306 14.1869 12.4306 12.6528C12.4306 11.1187 11.1869 9.875 9.65278 9.875C8.11865 9.875 6.875 11.1187 6.875 12.6528C6.875 14.1869 8.11865 15.4306 9.65278 15.4306Z",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1247 16.1247L11.6143 14.6143",
    stroke: "#808191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27150_14870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.33333,
    height: 8.33333,
    fill: "white",
    transform: "translate(5.83301 8.83301)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSearch);
export default __webpack_public_path__ + "static/media/file-search.afc67ce436bc4351501cc1d194ad3cc4.svg";
export { ForwardRef as ReactComponent };